export default {
    name: 'da',
    messages: {
        max_stripped_length: (field, [length]) => `${field} må ikke fylde mere end ${length} tegn.`,
        min_stripped_length: (field, [length]) => `${field} skal mindst fylde ${length} tegn.`,
        max_dimensions: (field, [width, height]) => `${field} må højest være ${height} pixels høj og ${width} pixels bred.`,
        min_dimensions: (field, [width, height]) => `${field} skal mindst være ${height} pixels høj og ${width} pixels bred.`,
    },
};



// WEBPACK FOOTER //
// ./src/global/validation/localization/da.js